import LifeCoverage from '@/modules/life/common/models/MID/LifeCoverage'

export default class LifeRaterPriceInsuredToSave {
  /** (String): Código postal del asegurado. */
  postalCode!: string

  /** (DateTime): Fecha de nacimiento del asegurado. */
  birthDate!: string

  /** (Integer): Orden del asegurado. */
  riskNumber!: number

  /** (string): Actividad del asegurado  */
  activity?: string

  /** (string): Profesión del asegurado */
  profession?: string

  /** (Coverage): Coberturas contratadas para el asegurado */
  coverages: LifeCoverage[]

  constructor(data: any) {
    if (data.postalCode) {
      this.postalCode = data.postalCode
    }

    this.birthDate = data.birthDate
    this.riskNumber = data.riskNumber
    this.activity = data?.activity ?? undefined
    this.profession = data?.profession ?? undefined
    this.coverages = data.coverages.map(
      (c: LifeCoverage) =>
        new LifeCoverage({
          coverageCode: c.coverageCode,
          sumInsured: c.sumInsured
        })
    )
  }
}
